export enum Lookup {
  PROPERTY_TYPE = 'Property_Type',
  STATUS_LIST = 'Locale_Listing_Statuses',
  STANDARD_STATUS = 'StandardStatus',
  STREET_DIRECTIONS = 'Street_Directions',
  STREET_TYPES = 'Street_Types',
}
